import React, { PureComponent, ReactNode } from 'react'
import clsx from 'clsx'

import './TileButton.scss'

interface TileButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children: ReactNode,
  type: 'submit' | 'button',
  active: boolean,
  className: string
}

class TileButton extends PureComponent<TileButtonProps> {
  static defaultProps: Partial<TileButtonProps> = {
    type: 'button',
    active: false,
    className: ''
  }

  render() {
    const {
      children,
      active: isActive,
      className,
      ...props
    } = this.props

    return (
      <button
        {...props}
        className={clsx(
          'tile-button',
          {'tile-button_active': isActive},
          className
        )}
      >
        <span className="tile-button__inner">{children}</span>
      </button>
    )
  }
}

export default TileButton
